import styled from 'styled-components'

import { helpers } from 'styles'

export const Title = styled.h2`
	font-size: ${helpers.font.size.larger};
	font-weight: 700;
`
